import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputTrimmerDirective } from './input-trimmer.directive';

@NgModule({
  declarations: [InputTrimmerDirective],
  imports: [
    CommonModule
  ],
  exports: [
    InputTrimmerDirective
  ]
})
export class InputTrimmerModule { }
